import mapRelationship from '@/utils/mapRelationship'

// True while the customer still has unused meal-plan allotment to put in this
// cart (included < available). The pricing-tier progress bar is suppressed
// while this holds: included meals never count toward tier thresholds, so
// "Add N items for X% off" is noise until the plan meals are used up.
export default function mealPlanMealsStillAvailable(store, v2Cart = null) {
  if (v2Cart) {
    return (v2Cart?.meal_plan?.balance_remaining_after_cart || 0) > 0
  }
  const customer = store.getters.customer
  const subscription = mapRelationship(store.state, customer?.relationships?.meal_plan_subscription?.data)
  const available = subscription?.attributes?.remaining_meal_credits
  if (!available) return false
  const included = store.getters.currentCart?.attributes?.meal_plan_included_count || 0
  return included < available
}
